const h = {
  name: "ParisEiffel",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M23,3h-2V0h-2v3h-2v4h-1v2h1.8c-0.6,4.1-1.5,8.1-2.7,12H13v2h1.5c-1.2,3.9-2.7,7.7-4.5,11.4L8.4,38H0v2h40v-2
			h-8.4l-1.7-3.6c-1.7-3.7-3.2-7.5-4.5-11.4H27v-2h-2.2c-1.2-3.9-2.1-7.9-2.7-12H24V7h-1V3z M20,35c1.9,0,3.4,1.3,3.9,3h-7.7
			C16.6,36.3,18.1,35,20,35z M14.1,38h-3.5l1.3-2.8c0-0.1,0.1-0.2,0.1-0.2h3.5C14.8,35.8,14.3,36.9,14.1,38z M25.9,38
			c-0.2-1.1-0.7-2.2-1.4-3H28c0,0.1,0.1,0.2,0.1,0.2l1.3,2.8H25.9z M22.8,21h-5.5c1.1-3.9,2-7.9,2.6-12h0.3
			C20.8,13.1,21.6,17.1,22.8,21z M16.6,23H19v6h-4.5C15.3,27,16,25,16.6,23z M23.4,23c0.6,2,1.3,4,2.1,6H21v-6H23.4z M12.9,33
			c0.3-0.7,0.6-1.3,0.9-2h12.5c0.3,0.7,0.6,1.3,0.9,2H12.9z M21,7h-2V5h2V7z"/>
	</g>
</g>
</svg>
  `
};
export {
  h as ParisEiffel
};
